import { render, staticRenderFns } from "./dashed.vue?vue&type=template&id=15058b0e&"
import script from "./dashed.vue?vue&type=script&lang=js&"
export * from "./dashed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports